import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import { StepFunctions } from "../joyrideSteps";
import { useState } from "react";
import StartStep from "./StartStep";
import { useTranslation } from "react-i18next";

const ScheduleOpen: React.FC<StepFunctions> = ({ goToStep }) => {
    const { t } = useTranslation();
    const [showStartStep, setShowStartStep] = useState(false);
    const handleButtonClick = () => setShowStartStep(true);

    return (
        <div>
            {showStartStep ? (
                <StartStep setShowStartStep={setShowStartStep} />
            ) : (
                <Row>
                    <Col xs={11}>
                        <span className="fs-normal fw-bold fs-7">{t('Open "Work schedule settings"')}</span>
                    </Col>
                    <Col xs={1} className="p-0 text-center">
                        <Button variant="link" className="p-0" onClick={handleButtonClick}>
                            <i className="bi bi-x-lg "></i>
                        </Button>
                    </Col>
                </Row>
            )}
        </div>
    );
};

export default ScheduleOpen;
